import React from 'react';
import { usePricingContext } from '../context/PricingContext';
interface PriceDisplayProps {
  type?: 'current' | 'compare';
  className?: string;
}
export function PriceDisplay({
  type = 'current',
  className = ''
}: PriceDisplayProps) {
  const {
    currentPrice,
    comparePrice,
    loading
  } = usePricingContext();
  if (loading) {
    return <span className={className} style={{
      opacity: 0.4
    }} data-id="element-108">
        ...
      </span>;
  }
  return <span className={className} data-id="element-109">
      {type === 'compare' ? comparePrice : currentPrice}
    </span>;
}